import { Component, inject, OnInit, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { OrderEntity, OrderStatusEnum } from '@domain';
import { RaButtonComponent, RaInputComponent, RaLoadingComponent } from '@shared/components';
import { TranslatePipe } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { OrderCreateComponent } from 'src/app/modules/order/components/create/order-create.component';
import { OrderCardComponent } from 'src/app/modules/order/components/order-card/order-card.component';
import { OrderCardSkeletonComponent } from 'src/app/modules/order/components/order-card-skeleton/order-card-skeleton.component';
import { RaEmptyComponent } from 'src/app/shared/components/ra-empty/ra-empty.component';
import { RaSquareIconComponent } from 'src/app/shared/components/ra-square-icon/ra-square-icon.component';
import { OrderArchivedPanelComponent } from '../order-archived-panel/order-archived-panel.component';
import { OrderMainService } from '../../services/order-main.service';

@Component({
    selector: 'order-list',
    templateUrl: 'order-list.component.html',
    styleUrl: 'order-list.component.scss',
    imports: [
        RaEmptyComponent,
        RaInputComponent,
        OrderCardComponent,
        OrderCardSkeletonComponent,
        RaLoadingComponent,
        ReactiveFormsModule,
        RaButtonComponent,
        RaSquareIconComponent,
        OrderCreateComponent,
        OrderArchivedPanelComponent,
        TranslatePipe,
    ],
})
export class OrderListComponent implements OnInit {
    public searchControl = new FormControl('');
    public status = signal<OrderStatusEnum>(OrderStatusEnum.PROGRESS);
    public isMouseInsideContainer = signal<boolean>(false);
    public isModalCreateOrderVisible = signal<boolean>(false);
    public isArchivedPanelVisible = signal<boolean>(false);

    // Placeholders exibidos enquanto a primeira página carrega
    protected readonly skeletons = Array.from({ length: 6 });

    // * [Injects]
    public orderMainService = inject(OrderMainService);

    ngOnInit(): void {
        this._listenSearchControl();
        this.getOrders();
    }

    /**
     * Escuta as mudanças no input de busca
     */
    private _listenSearchControl(): void {
        this.searchControl.valueChanges
            // Sem `skip(1)`: `valueChanges` não emite o valor inicial, e pular o primeiro
            // evento fazia uma busca colada de uma vez só não disparar
            .pipe(debounceTime(600), distinctUntilChanged())
            .subscribe(() => this.getOrders());
    }

    /**
     * Busca os serviços
     */
    public getOrders(page: number = 1): void {
        // O campo de busca nunca é travado durante a busca: desabilitar tirava o foco
        // e engolia o que era digitado. O loading aparece no próprio campo.
        this.orderMainService.getAllOrders(this.status(), this.searchControl.value, page).subscribe();
    }

    /**
     * Evento de criação de serviço realizado com sucesso
     * @param order Serviço criado
     */
    public orderCreated(order: OrderEntity): void {
        this.orderMainService.orders.update(orders => [order, ...orders]);

        this.orderMainService.setOrder(order);
        this.isModalCreateOrderVisible.set(false);
    }
}
